import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Index from "./pages/index.jsx"
import ThankYou from "./pages/thankyou.jsx";

function App() {
  return (
    <div>
        <BrowserRouter>
            <Routes>
                <Route
                    path={"/"}
                    element={<Index />}
                />
                <Route
                    path={"/thank-you"}
                    element={<ThankYou />}
                />
            </Routes>
        </BrowserRouter>     
    </div>
  );
}

export default App;
